// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog-container {
  min-height: -moz-fit-content;
  min-height: fit-content;
  min-width: 150px;
  width: 20vw;
  display: flex;
  flex-direction: column;
}
.dialog-container .mat-dialog-title {
  display: inline-block;
}
.dialog-container .mat-dialog-title > * {
  vertical-align: middle;
  margin-right: 1rem;
}
.dialog-container .mat-dialog-content * {
  text-align: justify;
}
.dialog-container .mat-dialog-content,
.dialog-container .mat-form-field,
.dialog-container .mat-dialog-actions,
.dialog-container button {
  width: 100%;
  margin: 0;
  padding: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/components/inject-dialog/inject-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,4BAAA;EAAA,uBAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;AACF;AACE;EACE,qBAAA;AACJ;AACI;EACE,sBAAA;EACA,kBAAA;AACN;AAII;EACE,mBAAA;AAFN;AAME;;;;EAIE,WAAA;EACA,SAAA;EACA,UAAA;AAJJ","sourcesContent":[".dialog-container {\r\n  min-height: fit-content;\r\n  min-width: 150px;\r\n  width: 20vw;\r\n  display: flex;\r\n  flex-direction: column;\r\n\r\n  .mat-dialog-title {\r\n    display: inline-block;\r\n\r\n    & > * {\r\n      vertical-align: middle;\r\n      margin-right: 1rem;\r\n    }\r\n  }\r\n\r\n  .mat-dialog-content {\r\n    * {\r\n      text-align: justify;\r\n    }\r\n  }\r\n\r\n  .mat-dialog-content,\r\n  .mat-form-field,\r\n  .mat-dialog-actions,\r\n  button {\r\n    width: 100%;\r\n    margin: 0;\r\n    padding: 0;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
